import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchUnhandledActivitiesCount, fetchBase64Yimg, fetchNotifications } from '../../../actions'
import {
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../../actions/common'
import { withRouter } from 'react-router-dom'
import CommonPage from '../../../components/Proposal/Common/CommonPage'

const mapStateToProps = (state, ownProps) => {
  return {
    supplier: state.supplier,
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    fetchUnhandledActivitiesCount,
    fetchBase64Yimg,
    fetchNotifications
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

const MappedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonPage)

export default withRouter(MappedContainer)
